module.exports = __webpack_public_path__ + "img/content7.ace0a53f.png";